var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDribbbleIconColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dribbble_icon",
    transform: "translate(0 0.068)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_34",
    "data-name": "Elipse 34",
    cx: 17,
    cy: 17,
    r: 17,
    transform: "translate(0 -0.068)",
    fill: "#ff3900"
  }), /*#__PURE__*/React.createElement("g", {
    id: "dribbble-ball-mark",
    transform: "translate(10 9.932)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "dribbble-ball-mark-2",
    "data-name": "dribbble-ball-mark",
    d: "M7.351,0A7.61,7.61,0,0,0,0,7.841a7.61,7.61,0,0,0,7.351,7.841A7.615,7.615,0,0,0,14.7,7.841,7.615,7.615,0,0,0,7.351,0Zm4.855,3.614a6.94,6.94,0,0,1,1.419,4.167,13.92,13.92,0,0,0-4.369-.213c-.048-.111-.088-.23-.136-.349-.128-.323-.271-.655-.415-.969A8.482,8.482,0,0,0,12.206,3.614ZM7.351,1.157A6.047,6.047,0,0,1,11.513,2.84,7.173,7.173,0,0,1,8.22,5.256a36.514,36.514,0,0,0-2.344-3.92A6,6,0,0,1,7.351,1.157ZM4.68,1.786A42.667,42.667,0,0,1,7.008,5.655a22.148,22.148,0,0,1-5.8.816A6.667,6.667,0,0,1,4.68,1.786ZM1.068,7.849v-.2a21.588,21.588,0,0,0,6.45-.952c.183.374.351.757.51,1.14l-.247.077a10.208,10.208,0,0,0-5.1,4.414A6.938,6.938,0,0,1,1.068,7.849Zm6.282,6.693A5.992,5.992,0,0,1,3.5,13.13,8.821,8.821,0,0,1,8.427,8.946c.016-.009.024-.009.04-.017a29.156,29.156,0,0,1,1.339,5.077A5.845,5.845,0,0,1,7.351,14.542Zm3.5-1.148a30.369,30.369,0,0,0-1.22-4.771,8.625,8.625,0,0,1,3.907.289A6.7,6.7,0,0,1,10.851,13.394Z",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDribbbleIconColor);
export default __webpack_public_path__ + "static/media/dribbble_icon_color.d1e7ee43537ca455e04d2aa8363f28dc.svg";
export { ForwardRef as ReactComponent };